<div class="header layout-corral">
  <div class="header-top-menu">
    <a class="burger" (click)="openMobileMenu()">
      <ico ico="burger"></ico>
    </a>
    <a class="header-top-menu-logo" [routerLink]="rootPage?.link">
      <img src="assets/images/logo.svg" alt="">
    </a>
    <a class="header-top-menu-ref" [routerLink]="'search'">
      <ico ico="search_24" [size]="24"></ico>
    </a>
    <locale></locale>
    <a class="header-top-menu-login" (click)="login()" *ngIf="!isLoggedIn">
      <ico ico="profile_24" [size]="24"></ico>
    </a>
    <header-user-bar *ngIf="isLoggedIn"></header-user-bar>
    <a class="btn outline" href="">
      МТК 523
    </a>
    <a class="btn outline" href="">
      Портал ТК 023
    </a>
  </div>

  <pages-menu class="lvl-0"></pages-menu>
  
</div>
